export default __webpack_public_path__ + "static/parent-card-27abffa38e365c633594b84e60d0ba18.png";